//@ts-check
import validation from '../validation';
/**
 * @param {import('./types').EcrionFormState} state
 * @param {string} pageId
 * @returns {import('./types').EcrionFormState}
 */

var changePage = function changePage(state, pageId) {
  var canChangePage = validateChanging(state, pageId);
  if (canChangePage) state.meta['FORM_PAGES_FIELD'] = pageId;
  return state;
};
/**
 * @param {import('./types').EcrionFormState} state
 * @param {string} pageId
 * @returns {boolean}
 */


var validateChanging = function validateChanging(state, pageId) {
  var layout = state.layout,
      formId = state.formId;
  var formField = state.fields[formId]; // validate before next page is an option in form in order to disabled this behavior

  if (formField.type !== 'form' || !formField.validateBeforeNextPage) return true;
  var crtPageId = state.meta['FORM_PAGES_FIELD'] + '';
  var crtPageIdx = layout.pages.indexOf(crtPageId);
  var nextPageIdx = layout.pages.indexOf(pageId); // going to a previous page doesn't require validation

  if (nextPageIdx < crtPageIdx) return true;
  var invalidFields = validation.validatePage(state, crtPageId);
  if (!invalidFields.length) return true;
  state.meta = state.meta || {};
  invalidFields.forEach(function (invalidField) {
    var fieldId = invalidField.fieldId,
        error = invalidField.error;
    state.meta[fieldId] = state.meta[fieldId] || {};
    state.meta[fieldId].error = error || '';
  }); // remove old active field

  Object.keys(state.meta).forEach(function (key) {
    if (state.meta[key].active) state.meta[key].active = false;
  }); // first invalid field is now active

  state.meta[invalidFields[0].fieldId].active = true;
  return false;
};

export default {
  changePage: changePage
};